<template>
  <div class="search-suggestions">
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'SanitasFormSearchSugestion',
  props: {
    suggestion: {
      type: String,
      default: '',
    },
    searchValue: {
      type: String,
      default: '',
    },
  },
  computed: {
    content() {
      const { suggestion, searchValue } = this
      const localSearchValue = searchValue.trim()

      const matchPos = suggestion
        .toLowerCase()
        .indexOf(localSearchValue.toLowerCase())
      const start = suggestion.substr(0, matchPos)
      const highlight =
        '<span class="highlight">' +
        suggestion.substr(matchPos, localSearchValue.length) +
        '</span>'
      const end = suggestion.substr(matchPos + localSearchValue.length)

      return start + highlight + end
    },
  },
}
</script>

<style scoped>
.search-suggestions {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 5px;
  border-radius: var(--border-radius);
  font-weight: 300;
  font-style: normal;
  line-height: 1.25;
  font-size: 18px;
  color: var(--c-secondary-neutral-2);

  @media (--xl) {
    font-size: 24px;
  }
  .highlight {
    font-weight: 700;
    font-style: normal;
    font-size: 18px;
    line-height: 1.25;
    color: var(--c-secondary-neutral-2);

    @media (--xl) {
      font-size: 24px;
    }
  }

  &.is-negative {
    color: var(--c-secondary-neutral-2);
    .highlight {
      color: var(--c-secondary-neutral-2);
    }
  }

  &.is-combobox {
    border-radius: 0;
  }

  &:hover,
  &.selected {
    cursor: pointer;
    color: var(--c-primary-neutral-3);
    background-color: var(--c-primary-color-3);

    .highlight {
      color: var(--c-primary-neutral-3);
    }
  }
}
</style>
